/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService
 */
import * as References from './ScopeGapsService';
import { createRpcClientV2, type RpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import {
  DataFetchingClientFetcherContext,
  RegisteredQuery,
} from 'data-fetching-client';
import { registerQuery } from 'data-fetching-client/next';
export type AdditionalContextArgs = {
  /**
   * Timeout for the request in milliseconds. If not provided, the timeout configured for this RPC is used, falling back to 5000.
   */
  timeout?: number;
  /**
   * Not recommended for usage. Please use build time client instead by updating `.client-types.config.ts`file.
   * Docs: https://product.hubteam.com/docs/chirp/pages/tutorials/chirp/FE/custom-clients.html.
   *
   * Used to overwrite the default Chirp Client during runtime.
   */
  customClient?: RpcClientV2;
};

export const chirpClient = createRpcClientV2({
  hubHttpClient: http,
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getProductHierarchy
 */
export const GET_PRODUCT_HIERARCHY_QUERY_FIELD_NAME =
  'com_hubspot_scopegaps_rpc_ScopeGapsService_getProductHierarchy';
export const GET_PRODUCT_HIERARCHY_QUERY: RegisteredQuery<
  'result',
  References.GetProductHierarchyRequestType,
  References.GetProductHierarchyResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_PRODUCT_HIERARCHY_QUERY_FIELD_NAME,
  args: ['frontendLocale', 'javaLocaleLanguageTag'],
  fetcher(
    request: References.GetProductHierarchyRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetProductHierarchyResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getProductHierarchyRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getSatisfyingOptions
 */
export const GET_SATISFYING_OPTIONS_QUERY_FIELD_NAME =
  'com_hubspot_scopegaps_rpc_ScopeGapsService_getSatisfyingOptions';
export const GET_SATISFYING_OPTIONS_QUERY: RegisteredQuery<
  'result',
  References.GetSatisfyingOptionsRequestType,
  References.GetSatisfyingOptionsResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SATISFYING_OPTIONS_QUERY_FIELD_NAME,
  args: [
    'scopes',
    'scopeGroups',
    'minimal',
    'frontendLocale',
    'javaLocaleLanguageTag',
  ],
  fetcher(
    request: References.GetSatisfyingOptionsRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSatisfyingOptionsResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSatisfyingOptionsRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getSatisfyingCombos
 */
export const GET_SATISFYING_COMBOS_QUERY_FIELD_NAME =
  'com_hubspot_scopegaps_rpc_ScopeGapsService_getSatisfyingCombos';
export const GET_SATISFYING_COMBOS_QUERY: RegisteredQuery<
  'result',
  References.GetSatisfyingCombosRequestType,
  References.GetSatisfyingCombosResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SATISFYING_COMBOS_QUERY_FIELD_NAME,
  args: [
    'scopes',
    'scopeGroups',
    'minimal',
    'frontendLocale',
    'javaLocaleLanguageTag',
  ],
  fetcher(
    request: References.GetSatisfyingCombosRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSatisfyingCombosResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSatisfyingCombosRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getSatisfyingCombosBatch
 */
export const GET_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME =
  'com_hubspot_scopegaps_rpc_ScopeGapsService_getSatisfyingCombosBatch';
export const GET_SATISFYING_COMBOS_BATCH_QUERY: RegisteredQuery<
  'result',
  References.GetSatisfyingCombosBatchRequestType,
  References.GetSatisfyingCombosBatchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(
    request: References.GetSatisfyingCombosBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetSatisfyingCombosBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getSatisfyingCombosBatchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getFullSatisfyingCombos
 */
export const GET_FULL_SATISFYING_COMBOS_QUERY_FIELD_NAME =
  'com_hubspot_scopegaps_rpc_ScopeGapsService_getFullSatisfyingCombos';
export const GET_FULL_SATISFYING_COMBOS_QUERY: RegisteredQuery<
  'result',
  References.GetFullSatisfyingCombosRequestType,
  References.GetFullSatisfyingCombosResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_FULL_SATISFYING_COMBOS_QUERY_FIELD_NAME,
  args: [
    'scopes',
    'scopeGroups',
    'minimal',
    'frontendLocale',
    'javaLocaleLanguageTag',
  ],
  fetcher(
    request: References.GetFullSatisfyingCombosRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetFullSatisfyingCombosResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getFullSatisfyingCombosRpc,
      { timeout: ctx.timeout, request }
    );
  },
});

/**
 * Docs: https://private.hubteam.com/shoebill/service/com.hubspot.scopegaps.rpc.ScopeGapsService#getFullSatisfyingCombosBatch
 */
export const GET_FULL_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME =
  'com_hubspot_scopegaps_rpc_ScopeGapsService_getFullSatisfyingCombosBatch';
export const GET_FULL_SATISFYING_COMBOS_BATCH_QUERY: RegisteredQuery<
  'result',
  References.GetFullSatisfyingCombosBatchRequestType,
  References.GetFullSatisfyingCombosBatchResponseType
> = /* #__PURE__ */ registerQuery({
  fieldName: GET_FULL_SATISFYING_COMBOS_BATCH_QUERY_FIELD_NAME,
  args: ['requests'],
  fetcher(
    request: References.GetFullSatisfyingCombosBatchRequestType,
    ctx: DataFetchingClientFetcherContext & AdditionalContextArgs
  ): Promise<References.GetFullSatisfyingCombosBatchResponseType> {
    return (ctx.customClient ?? chirpClient).call(
      References.getFullSatisfyingCombosBatchRpc,
      { timeout: ctx.timeout, request }
    );
  },
});
